import { Container, Segment } from '@mairistem/composants';
import React from 'react';
import SubventionListeRiche from '@/src/components/Dashboard/SubventionListeRiche/SubventionListeRiche';

const Dashboard = () => (
	<Container as={Segment} attached className="dashboard">
		<SubventionListeRiche />
	</Container>
);

export default Dashboard;
